import { useLocation } from "react-router-dom";
import Sidebar from "@/components/sidebar/sidebar";
import Header from "@/components/header/header";

export default function ConditionalLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  const pathname = location.pathname;

  // Routes that should not have the main layout (sidebar + header)
  const fullScreenRoutes = [
    "/webbuilder/edit",
    "/webbuilder/onboarding/edit",
  ];

  const isFullScreenRoute = fullScreenRoutes.some((route) =>
    (pathname) ? pathname.includes(route) : false,
  );

  if (isFullScreenRoute) {
    return <>{children}</>;
  }

  return (
    <main className="h-screen w-screen flex overflow-hidden bg-background text-foreground text-[15px]">
      <Sidebar />
      <div className="flex-1 bg-background overflow-auto">
        <Header />
        <div className="p-2.5">{children}</div>
      </div>
    </main>
  );
}
